// Pricing Configuration - Promotional Rates (To attract traffic)
// Updated: Based on traffic-building strategy

export const PRICING = {
  // Premium Listings
  PREMIUM_MONTHLY: 85,      // Promotional: R85/month (was R299)
  PLATINUM_MONTHLY: 110,    // Promotional: R110/month (was R599)
  
  // Advertisement Rates
  HOMEPAGE_BANNER_MONTHLY: 500,      // R500/month (was R1,999)
  SIDEBAR_AD_MONTHLY: 160,           // R160/month (was R499)
  CATEGORY_PROMOTION_MONTHLY: 200,   // R200/month (new)
  
  // Sponsored Content
  SPONSORED_BLOG_POST: 500,          // R500 per article (was R2,999-4,999)
  
  // Free Services (Promotional - To attract traffic)
  BOOKING_FEE: 0,                     // FREE (was R25-50)
  JOB_POST_STANDARD: 0,               // FREE (was R199)
  JOB_POST_FEATURED: 0,               // FREE (was R399)
  JOB_POST_URGENT: 0,                 // FREE (was R299)
  PRIORITY_BOOKING: 0,                // FREE (was R49)
  USER_SUBSCRIPTION_PRO: 0,           // FREE (was R99/month)
  TRANSFER_REQUEST_PROMOTION: 0,      // FREE (was R99)
  
  // Enhanced Profile Features (Currently Free)
  MULTIPLE_PHOTOS: 0,                 // FREE (was R99/month)
  VIDEO_PROFILE: 0,                   // FREE (was R199/month)
  BUSINESS_HOURS_CUSTOMIZATION: 0,    // FREE (was R49/month)
  CUSTOM_CTA_BUTTONS: 0,              // FREE (was R149/month)
} as const;

// Payment Type Configuration
export const PAYMENT_TYPES = {
  PREMIUM_LISTING: 'premium_listing',
  BOOKING_FEE: 'booking_fee',
  FEATURED_PROMOTION: 'featured_promotion',
  JOB_POST: 'job_post',
  SUBSCRIPTION: 'subscription',
  BOOKING_PRIORITY: 'booking_priority',
  HOMEPAGE_BANNER: 'homepage_banner',
  SIDEBAR_AD: 'sidebar_ad',
  CATEGORY_PROMOTION: 'category_promotion',
  SPONSORED_CONTENT: 'sponsored_content',
} as const;

// Get pricing for payment type
export const getPricingForType = (paymentType: string): number => {
  switch (paymentType) {
    case PAYMENT_TYPES.PREMIUM_LISTING:
      return PRICING.PREMIUM_MONTHLY;
    case 'platinum_listing':
      return PRICING.PLATINUM_MONTHLY;
    case PAYMENT_TYPES.BOOKING_FEE:
      return PRICING.BOOKING_FEE;
    case PAYMENT_TYPES.HOMEPAGE_BANNER:
      return PRICING.HOMEPAGE_BANNER_MONTHLY;
    case PAYMENT_TYPES.SIDEBAR_AD:
      return PRICING.SIDEBAR_AD_MONTHLY;
    case PAYMENT_TYPES.CATEGORY_PROMOTION:
      return PRICING.CATEGORY_PROMOTION_MONTHLY;
    case PAYMENT_TYPES.SPONSORED_CONTENT:
      return PRICING.SPONSORED_BLOG_POST;
    case PAYMENT_TYPES.JOB_POST:
      return PRICING.JOB_POST_STANDARD;
    case PAYMENT_TYPES.BOOKING_PRIORITY:
      return PRICING.PRIORITY_BOOKING;
    default:
      return 0;
  }
};

// Note: Prices will increase once platform has enough traffic (after 2 months)




